export default __webpack_public_path__ + "static/media/park_linowy_regulamin_zal_5.063cb705.doc";